export function resolveTeamDisplayName(team: {
  displayName?: string;
  name: string;
}): string {
  return team.displayName || team.name;
}
